import { render, staticRenderFns } from "./estudantes.vue?vue&type=template&id=95edb9f2&scoped=true&"
import script from "./estudantes.vue?vue&type=script&lang=js&"
export * from "./estudantes.vue?vue&type=script&lang=js&"
import style0 from "./estudantes.vue?vue&type=style&index=0&id=95edb9f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95edb9f2",
  null
  
)

export default component.exports